import React from 'react';
import { useTranslation } from 'react-i18next';

import { CookiePrefrences } from './CookiePreferences';

import './styles.css';

const PRIVACY_URL = 'https://aws.amazon.com/privacy/?nc1=f_pr';
const SITE_TERMS = 'https://aws.amazon.com/terms/?nc1=f_pr';

const Footer = (): JSX.Element => {
  const { t } = useTranslation();
  return (
    <footer className="footer" id="footer">
      <div className="footerWrapper">
        <ul>
          <li>
            <a className="footerLink" href={PRIVACY_URL}>
              {t('footer.privacy')}
            </a>
          </li>
          <li style={{ color: 'rgb(126, 147, 238) !important' }}>|</li>
          <li>
            <a className="footerLink" href={SITE_TERMS}>
              {t('footer.siteTerms')}
            </a>
          </li>
          <li style={{ color: 'rgb(126, 147, 238) !important' }}>|</li>
          <li>
            <CookiePrefrences />
          </li>
          <li style={{ color: 'rgb(126, 147, 238) !important' }}>|</li>
          <li>
            <p>{t('footer.copyright')}</p>
          </li>
        </ul>
      </div>
    </footer>
  );
};

export default Footer;
